import { IResponse, ObjectsFactory } from '@/data/core'
import { Model } from '@/data/core/model'
import { NOTIFY_ENDPOINT } from '@/data/endpoint'

export type SubscriptionType = 'trade' | 'deposit'
export type SubscriptionStatus = 'active' | 'pending' | 'inactive'
export type ProviderType = 'telegram' | 'discord'

export interface SubscribeTransactionNotifyRequest {
  type: SubscriptionType
  referenceId: string
  provider: ProviderType
}

export interface SubscribeTransactionNotifyResponse {
  type: SubscriptionType
  referenceId: string
  provider: ProviderType
  status: SubscriptionStatus
  uniqueCode: string
  deepLink: string
}

export interface GetSubscriptionResponse {
  id: number
  type: SubscriptionType
  referenceId: string
  provider: ProviderType
  providerId: string
  status: SubscriptionStatus
  uniqueCode: string
  connectedAt: string
  createdAt: string
  updatedAt: string
}

export class NotifyModel extends Model {
  static config = { endpoint: NOTIFY_ENDPOINT.BASE }

  static objects = ObjectsFactory.factory<void>(NotifyModel.config)

  static subscribeTransactionNotify(payload: SubscribeTransactionNotifyRequest) {
    return this.service.post<IResponse<SubscribeTransactionNotifyResponse>>({
      url: NOTIFY_ENDPOINT.SUBSCRIPTIONS,
      payload,
    })
  }

  static getSubscription(referenceId: string) {
    return this.service.get<IResponse<GetSubscriptionResponse>>({
      url: `${NOTIFY_ENDPOINT.SUBSCRIPTIONS}/${referenceId}`,
    })
  }
}

NotifyModel.init(NotifyModel.config)
